exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /app/SPA/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 1